module.exports = __webpack_public_path__ + "img/eq-plate-boots.9ee93e03.png";